import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArrowDown(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M18.707 12.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L11 16.586V5a1 1 0 1 1 2 0v11.586l4.293-4.293a1 1 0 0 1 1.414 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
